// extracted by mini-css-extract-plugin
export default {"video_box":"index_video_box_yfWdQ","video":"index_video_yurMb"};